import { put, select } from 'redux-saga/effects';
import { selectActiveZoomId, zoomReset } from 'features/content-zoom/contentZoomSlice';

export function* onContentUnlockedSaga() {
  const zoomId: string | null = yield select(selectActiveZoomId);

  if (!zoomId) {
    return;
  }

  yield put(zoomReset({ zoomId }));
}
